export default __webpack_public_path__ + "static/media/6.883c86d6.jpg";